/* eslint-disable react/no-multi-comp */
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import * as proposalSelectors from '@makemydeal/dr-dash-store/selectors/proposalSelectors';
import { SlideOut } from '@interstate/components/SlideOut';
import { Box } from '@interstate/components/Box';
import { useGetDrawerWidth } from '../dealActivity/activities/hooks/useGetDrawerWidth';
import { ProposalSlideOutProvider, useProposalSlideOutContext } from './ProposalSlideOutProvider';

// Inner component that consumes context
export const ProposalsSideOutInner: React.FC = () => {
    const { shown, hide, getTitle, getContent, getFooterProps, view } = useProposalSlideOutContext();
    const formWidth = useGetDrawerWidth({ tablet: 849 });
    const previewWidth = useGetDrawerWidth({ large: 1200, extraLarge: 1200, tablet: '90vw', small: '100vw', extraSmall: '100vw' });
    const width = view === 'preview' ? previewWidth : formWidth;
    const isLoadingPreviewError = useSelector(proposalSelectors.getProposalPreviewError);
    const slideOutContentRef = React.useRef<HTMLDivElement>(null);

    useEffect(() => {
        slideOutContentRef.current?.parentElement?.scrollTo(0, 0);
    }, [isLoadingPreviewError, view]);

    if (!shown) return null;

    return (
        <SlideOut
            id="printing-proposal-drawer"
            data-testid="printing-proposal-drawer"
            header={getTitle()}
            show={shown}
            position="right"
            panelWidth={width}
            onHide={hide}
            footer={getFooterProps()}
            sx={{
                '.ids-SlideOut-content': {
                    height: 'calc(100% - 135px)',
                    overflowY: 'hidden',
                    paddingBottom: '10px'
                }
            }}
        >
            <Box sx={{ height: '100%', overflowY: 'auto', px: 0.5 }} ref={slideOutContentRef}>
                {getContent()}
            </Box>
        </SlideOut>
    );
};

export interface ProposalsSideOutProps {
    initialView?: 'list' | 'create' | 'edit' | 'none';
}

// Wrapped component providing its own provider
export const ProposalsSideOut: React.FC<ProposalsSideOutProps> = () => {
    return (
        <ProposalSlideOutProvider>
            <ProposalsSideOutInner />
        </ProposalSlideOutProvider>
    );
};
